"use client"

import UniversalLink from "library/link"
import { css, fmobile, fresponsive, ftablet, styled } from "library/styled"
import { useRef, useState } from "react"
import colors from "styles/colors"
import textStyles from "styles/text"

export default function ToggleButtons({
	options = ["Employees", "Employers"],
	defaultOption = 0,
	onChange,
	className,
}: {
	options?: [string, string]
	defaultOption?: number
	onChange?: (selectedIndex: number) => void
	className?: string
}) {
	const [activeIndex, setActiveIndex] = useState(defaultOption)
	const containerRef = useRef<HTMLDivElement>(null)

	const handleToggle = (index: number) => {
		setActiveIndex(index)
		if (onChange) {
			onChange(index)
		}
	}

	return (
		<ToggleContainer ref={containerRef} className={className}>
			<SlidingPill
				style={{
					transform: `translateX(${activeIndex * 100}%)`,
				}}
			/>
			{options.map((option, index) => (
				<ToggleOption
					type="button"
					key={option}
					data-active={activeIndex === index}
					onClick={() => handleToggle(index)}
				>
					{option}
				</ToggleOption>
			))}
		</ToggleContainer>
	)
}

const ToggleContainer = styled("div", {
	...fresponsive(css`
		position: relative;
		display: flex;
		border-radius: 99vw;
		background-color: ${colors.green100Secondary};
		align-items: center;
		padding: 5px;
		width: 216px;
		height: 42px;
		border: 1px solid ${colors.greenAccent};
	`),

	...ftablet(css`
		width: 253px;
		height: 50px;
	`),

	...fmobile(css`
		width: 327px;
	`),
})

const ToggleOption = styled(UniversalLink, {
	...fresponsive(css`
		width: 50%;
		position: relative;
		border: none;
		background: none;
		${textStyles.bodyXXS};
		color: ${colors.greenAccent};
		cursor: pointer;
		text-align: center;
		z-index: 2;
		transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 0.5);
		height: 100%;

		&[data-active="true"] {
			color: ${colors.white};
		}
	`),

	...ftablet(css`
		${textStyles.bodyS};
	`),
})

const SlidingPill = styled("div", {
	...fresponsive(css`
		position: absolute;
		left: 6px;
		height: 32px;
		width: 102px;
		background: #0e5741;
		border-radius: 99vw;
		transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 0.5);
		z-index: 1;
		border-bottom: 1px solid #1b644e;
		border-left: 1px solid #1b644e;
		border-right: 1px solid #1b644e;
	`),

	...ftablet(css`
		width: 120px;
		height: 40px;
		left: 5px;
	`),

	...fmobile(css`
		width: 157px;
	`),
})
